import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { Http } from '@angular/http';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'container-action',
    templateUrl:'containerAction.html'
})
export class ContainerActionComponent implements OnInit{

  public isTrello
  public selectedBoardId
  public selectListId
  public isShopify
  public action
  public shopifyBoards;
  public lists;
  public boards


  public constructor(public translate: TranslationService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService,private http: Http) {
  }
  public saveData(){
    if (!this._appData.action){
      this._appData.action={kind:'container',param:{}}
    }
    document.getElementById('trigger-action-done').click();
  }

  public loadBoards(): void {
    const companyId = 'LIVEPLANET';
    const apiUrl = `https://us-central1-coolkids-669fa.cloudfunctions.net/getAllBoards?companyId=${companyId}`;

    this.http.get(apiUrl).subscribe(
      (response: any) => {
        this.boards = response.json();
      },
      (error) => {
        console.error('Erro ao carregar os boards:', error);
      }
    );
  }

  public reload(){
    this.loadBoards();
    this.loadShopifyBoards();
    this.action = this._appData.action;
    if (this.action.param.isTrello) {
      this.isTrello = true;
      this.selectedBoardId = this.action.param.trelloBoardId;
      this.selectListId = this.action.param.trelloListId;
      this.fetchListsForSelectedBoard() 
    }
    if (this.action.param.isShopify) {
      this.isShopify = true;
      this.selectedBoardId = this.action.param.shopifyBoardId;
    } 
  }
    public ngOnInit(): any {


    }


    public chooseBoard(): void {
      this.selectedBoardId = (document.getElementById('boardSelect') as HTMLSelectElement).value;
      console.log('Board selecionado:', this.selectedBoardId);
  
      this.action.param = {
        trelloBoardId: this.selectedBoardId,
        isTrello: true // Indica que é do Trello
      };
      this.fetchListsForSelectedBoard();
  
    }
    public chooseShopifyBoard(): void {
      this.selectedBoardId = (document.getElementById('boardSelect') as HTMLSelectElement).value;
      console.log('Board selecionado:', this.selectedBoardId);
      this.action.param = {
        shopifyBoardId: this.selectedBoardId,
        isShopify: true // Indica que é do Trello
      };
  
    }
  
    public fetchListsForSelectedBoard(): void {
      if (this.selectedBoardId) {
        const companyId = 'LIVEPLANET';
        const apiUrl = `https://us-central1-coolkids-669fa.cloudfunctions.net/getAllLists?companyId=${companyId}&boardId=${this.selectedBoardId}`;
  
        this.http.get(apiUrl).subscribe(
          (response: any) => {
            this.lists = response.json();
            this.lists.forEach(list => {
              list.isCollapsed = true;
              // Verifica se o ID da lista corresponde ao selectListId
              if (list.id === this.selectListId) {
                list.isCollapsed = false;
              }
            });
          },
          (error) => {
            console.error('Erro ao carregar as listas:', error);
          }
        );
      }
    }
  
    public loadShopifyBoards(): void {
      this._companyService.getShopifyCollections().subscribe(
          (response: any) => {
            let collections = response.json();
            collections.smart_collections.forEach(it=>{
              this.shopifyBoards.push({
                id:it.id.toString(),
                title:it.title
              })
            })
          },
          (error) => {
            console.error('Erro ao carregar as listas:', error);
          }
        );
    }
    public toggleTrelloList(list: any): void {
      // Verifica se a lista já está selecionada
      if (list.isSelected) {
        // Se já estiver selecionada, desmarca todas as listas
        this.lists.forEach(l => l.isSelected = false);
      } else {
        // Se não estiver selecionada, desmarca todas as listas e marca a lista atual
        this.lists.forEach(l => l.isSelected = false);
        list.isSelected = true;
      }
  
      // Atualiza o objeto 'item' com o ID da lista selecionada
      this.action.param.trelloListId = list.isSelected ? list.id : null;
    }
  
  
    public makeTrello(b){
      this.isTrello=b;
      if (b){
        this.action.param={
          isTrello:true
        }
      }
      else{
        this.action.param={}
      }
    }
    public makeShopify(b){
      this.isShopify=b;
      if (b){
        this.action.param={
          isShopify:true
        }
      }
      else{
        this.action.param={}
      }
    }
  
  }




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/containerAction.ts